module.exports = __webpack_public_path__ + "img/powerpoint.5d62bf21.svg";